import { useMemo } from "react";
import AppConstants from "./AppConstants";


export const useSeoData = ({ leagueName, page, teamName, editionName, seasonYear }) => {
  const seoData = useMemo(() => {

    const keywordsTemplate = AppConstants.SEO_KEYWORDS[page] || "";
    const descriptionTemplate = AppConstants.SEO_DESCRIPTIONS[page] || "";

    const applySeoTemplate  = (text) => {
      return text
        .replace(/{LEAGUE_NAME}/g, leagueName || "")
        .replace(/{TEAM_NAME}/g, teamName || "")
        .replace(/{EDITION_NAME}/g, editionName || "")
        .replace(/{SEASON_YEAR}/g, seasonYear || "");
    };

    return {
      keywords: applySeoTemplate (keywordsTemplate),
      description: applySeoTemplate (descriptionTemplate),
      hashtag: leagueName ? `#${leagueName.toLowerCase()}` : "",
      quote: AppConstants.SEO_QUOTE
    };
  }, [leagueName, page, teamName, editionName, seasonYear]);

  return seoData;
};